import { CSVLink } from "react-csv";
import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { convertISOToLocalDateObj, notify } from "../../functions/function";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { readableDateTime } from "../../functions/timeFormat";
import DateFnsUtils from "@date-io/date-fns";

function getEmployeeName(employee) {
  return employee.user.first_name + " " + employee.user.last_name;
}

const CsvGeneratorModal = ({ placements }) => {
  const [state, setState] = useState({
    show: false,
    startDate: new Date(),
    endDate: new Date(),
    loading: false,
    timesheets: [],
  });
  const csvDownloader = useRef(null);

  async function sortTimesheets(startDate, endDate) {
    var timesheets = [];
    placements.forEach((p) => {
      if (p.timesheet) {
        let start = convertISOToLocalDateObj(p.start_time);
        let end = convertISOToLocalDateObj(p.end_time);
        if (end >= startDate && start <= endDate) {
          timesheets.push({
            ...p.timesheet,
            employee: getEmployeeName(p.employee),
            clock_in_time: readableDateTime(p.timesheet.clock_in_time),
            clock_out_time: readableDateTime(p.timesheet.clock_out_time),
          });
        }
      }
    });
    return timesheets;
  }

  const handleDownload = async () => {
    setState({ ...state, loading: true });
    const timesheets = await sortTimesheets(state.startDate, state.endDate);

    if (timesheets && timesheets?.length) {
      await setState({
        ...state,
        timesheets,
      });
      csvDownloader.current.link.click();
    } else if (timesheets.length === 0) {
      notify(
        "No Timesheets",
        "You have not selected any timesheets to export",
        "warning"
      );
    } else {
      notify("Error", "There was an error. Please try again", "danger");
    }

    setState({ ...state, loading: false });
  };

  return (
    <div className="mb-3">
      {/* Unsure what information the clients can see and hence acces to this feature is not allowed
      <button
        type="button"
        class="btn btn-success justify-self-center"
        style={{ color: "white" }}
        onClick={() => {
          setState({ ...state, show: !state.show });
        }}
      >
        Generate Timesheet CSV
      </button> */}

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={state.show}
        onHide={() => setState({ ...state, show: !state.show })}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            CSV Generator
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Pick a date range</h4>
          <div className="row">
            <div className="col">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  value={state.startDate}
                  onChange={(e) => setState({ ...state, startDate: e })}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="col d-flex justify-content-center">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  value={state.endDate}
                  onChange={(e) => setState({ ...state, endDate: e })}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="col d-flex justify-content-end align-self-center">
              {state.loading ? (
                <div
                  class="spinner-border spinner-border-sm text-success"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <button
                  type="button"
                  class="btn btn-success d-flex"
                  style={{ color: "white" }}
                  onClick={() => handleDownload()}
                >
                  Generate
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            class="btn btn-dark justify-self-center"
            style={{ color: "white" }}
            onClick={() => {
              setState({ ...state, show: !state.show });
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <CSVLink
        ref={csvDownloader}
        data={state.timesheets}
        style={{ display: "none" }}
        filename={"timesheets.csv"}
      />
    </div>
  );
};

export default CsvGeneratorModal;
